const ClevertapConstant = {
    ONBOARDING_SCREEN_VIEWED: "ONBOARDING_SCREEN_VIEWED",
    ORDER_SESSION_INITIATED: "ORDER_SESSION_INITIATED",
    HOME_SCREEN_VIEWED: "HOME_SCREEN_VIEWED",
    BANNER_CLICKED: "BANNER_CLICKED",
    FILTER_APPLIED: "FILTER_APPLIED",
    BRAND_CLICKED: "BRAND_CLICKED",
    VIEW_ALL_CLICKED: "VIEW_ALL_CLICKED",
    ABOUT_EATSURE_CLICKED: "ABOUT_EATSURE_CLICKED",
    BACK_PRESSED: "BACK_PRESSED",
    RESTAURANT_CLICKED: "RESTAURANT_CLICKED",
    PRODUCT_CLICKED: "PRODUCT_CLICKED",
    SEARCH_CLICKED: "SEARCH_CLICKED",
    SIDEBAR_NAVIGATION_CLICKED: "SIDEBAR_NAVIGATION_CLICKED",
    DESSERTS_CLICKED: "DESSERTS_CLICKED",
    BEVERAGES_CLICKED: "BEVERAGES_CLICKED",
    STARTERS_CLICKED: "STARTERS_CLICKED",
    PRODUCT_ADDED: "PRODUCT_ADDED",
    PRODUCT_REMOVED: "PRODUCT_REMOVED",
    BRAND_VIEWED: "BRAND_VIEWED",
    CATEGORY_VIEWED: "CATEGORY_VIEWED",
    CUSTOMISATION_SCREEN: "CUSTOMISATION_SCREEN",
    CUSTOMISATION_SELECTED: "CUSTOMISATION_SELECTED",
    CUSTOMISATION_UNSELECTED: "CUSTOMISATION_UNSELECTED",
    CUSTOMISATION_RESET_CLICKED: "CUSTOMISATION_RESET_CLICKED",
    CUSTOMISATION_ADDED: "CUSTOMISATION_ADDED",
    CART_BAR_CLICKED: "CART_BAR_CLICKED",
    LOGIN_SCREEN_VIEWED: "LOGIN_SCREEN_VIEWED",
    LOGIN_OTP_REQUESTED: "LOGIN_OTP_REQUESTED",
    LOGIN_REGISTRATION_SCREEN: "LOGIN_REGISTRATION_SCREEN",
    LOGIN_VERIFICATION: "LOGIN_VERIFICATION",
    CART_SCREEN_VIEWED: "CART_SCREEN_VIEWED",
    CART_BOTTOM_BAR_CLICKED: "CART_BOTTOM_BAR_CLICKED",
    INSTRUCTIONS_ADDED: "INSTRUCTIONS_ADDED",
    PROCEED_TO_PAY: "PROCEED_TO_PAY",
    CHARGED: "CHARGED",
    ORDER_SESSION_CLOSED: "ORDER_SESSION_CLOSED",
    MENU_CLICKED: "MENU_CLICKED",
    MENU_SELECTION: "MENU_SELECTION",
    CART_BOTTOM_BAR_VIEWED: "CART_BOTTOM_BAR_VIEWED",
    PRODUCT_SEARCH_SCREEN_VIEWED: 'PRODUCT_SEARCH_SCREEN_VIEWED',
    PRODUCT_SEARCHED: 'PRODUCT_SEARCHED',
    APP_ERROR: 'APP_ERROR',
    UPSELL: 'UPSELL',
    UPSELL_SCROLLED: 'UPSELL_SCROLLED',
    PRODUCT_SEARCH_RESULT_SELECTED: 'PRODUCT SEARCH RESULT SELECTED'
}
export default ClevertapConstant;